import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RoutingService } from '@app/core/services/routing.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GetPaidService } from '../services/get-paid.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerInformationResolver implements Resolve<any> {
  constructor(private getPaidService: GetPaidService, private routingService: RoutingService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.getPaidService.getCustomer().pipe(
      catchError(error => {
        this.routingService.redirectError(error.status, state.url);
        return of(false);
      })
    );
  }
}
